module.exports = __webpack_public_path__ + "static/media/surface-tension.17a386b7.jpg";